// @flow

import { SYSTEM_GROUPS_SET, SYSTEM_GROUPS_ADD } from "../actions"

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case SYSTEM_GROUPS_ADD:
    return [ ...state, action.group ]
  case SYSTEM_GROUPS_SET:
    return [ ...action.groups ]
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/systemGroups.jsx